import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trades: [],
  activePositions: [],
  tradingStatus: 'idle'
};

const tradingSlice = createSlice({
  name: 'trading',
  initialState,
  reducers: {
    setTrades: (state, action) => {
      state.trades = action.payload;
    },
    setActivePositions: (state, action) => {
      state.activePositions = action.payload;
    },
    setTradingStatus: (state, action) => {
      state.tradingStatus = action.payload;
    }
  }
});

export const { setTrades, setActivePositions, setTradingStatus } = tradingSlice.actions;
export default tradingSlice.reducer;